import { ColoursObj } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useFormatValue } from '../../hooks/useFormatValue'
import { CardText } from '../subComponents/cardText'
import { ColouredIcon } from '../subComponents/colouredIcon'
interface IActivityDateProps {
    date?: string
    name?: string
}
export const ActivityDate = ({ date, name }: IActivityDateProps) => {
    const { formatValue } = useFormatValue()
    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={'8px'}>
                <ColouredIcon
                    name={'Activity'}
                    iconColour={ColoursObj.core.secondary}
                />
                <CardText variant="bodyBold">{name}</CardText>
            </Stack>
            <CardText variant="bodyBold">{formatValue(date ?? '', 'date')}</CardText>
        </Stack>
    )
}
